import React from 'react'
import { Table, TableBody, TableHead, TableRow, TableFooter } from '@material-ui/core'
import {useStyles, StyledTableCell, StyledTableRow } from '../styles'

export default function CurrentHeadCountSummaryReport(props) {

    const classes = useStyles()



    return (
        <div className={classes.reportTableContainer}>
            <Table id="CurrentHeadCountSummaryReport" className={classes.reportTable} size="small">
                <TableHead>
                    <TableRow>
                        <StyledTableCell className={classes.bgBlack}>
                            Global Grade
						</StyledTableCell>
                        <StyledTableCell className={classes.noBorder}></StyledTableCell>
                        <StyledTableCell className={classes.bgBlueGrey}>
                            n
						</StyledTableCell>
                        <StyledTableCell className={classes.bgBlueGrey}>
                            %
						</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        props.levelsData.map((levelData, i) => {
                            return (
                                <StyledTableRow key={i}>
                                    <StyledTableCell className={classes.bgBlack}>
                                        {i}
                                    </StyledTableCell>
                                    <StyledTableCell className={classes.bgWhite}></StyledTableCell>
                                    {
                                        Object.keys(props.groupSummary[i].current).map(value => {
                                            return (
                                                <React.Fragment key={`${i}${value}`}>
                                                    <StyledTableCell align="left" className={classes.bgWhite}>
                                                        {props.groupSummary[i].current[value]}
                                                    </StyledTableCell>
                                                </React.Fragment>
                                            )
                                        })
                                    }
                                </StyledTableRow>
                            )
                        })
                    }
                    <StyledTableRow>
                        <StyledTableCell className={classes.noBorder}></StyledTableCell>
                    </StyledTableRow>
                </TableBody>
                <TableFooter>
					<StyledTableRow>
                        <StyledTableCell className={classes.bgLightGreen} align='center'>Total {props.groupTotal.current.totalN}</StyledTableCell>
                        <StyledTableCell colSpan={1} className={classes.bgWhite}></StyledTableCell>
                        <StyledTableCell className={classes.bgLightGreen} align='center'>
                            {props.groupTotal.current.totalN}
                        </StyledTableCell>
                        <StyledTableCell className={classes.bgLightGreen} align='center'>
                            {props.groupTotal.current.totalPercent}
                        </StyledTableCell>
					</StyledTableRow>
				</TableFooter>
            </Table>
        </div >
    )
}
